import React from "react";
import Button from "@material-ui/core/Button";
import Create from "@material-ui/icons/Create";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core";

export const styles = theme => ({
  button: {
    flexShrink: 0,
    marginRight: 10
  },
  buttonSpinnerProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
});

class CreateQuickClip extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCreatingQuickClip: false
    };
  }

  render() {
    const { videoSearchStore, reelStore, classes } = this.props;
    return (
      <Tooltip title="Generate a clip with all plays" placement="left">
        <Button
          color="primary"
          className={classes.button}
          onClick={e => {
            // hide tooltip
            e.target.parentElement.blur();
            this.setState({ isCreatingQuickClip: true });
            videoSearchStore
              .getPlaysForQuickClip()
              .then(plays => {
                reelStore.createQuickClip(plays).finally(() => {
                  this.setState({ isCreatingQuickClip: false });
                });
              })
              .catch(reason => {
                this.setState({ isCreatingQuickClip: false });
              });
          }}
          disabled={this.state.isCreatingQuickClip}
        >
          <Create />
          Quick Clip
          {this.state.isCreatingQuickClip && (
            <CircularProgress
              size={24}
              className={classes.buttonSpinnerProgress}
            />
          )}
        </Button>
      </Tooltip>
    );
  }
}

export default inject(
  "reelStore",
  "videoSearchStore"
)(withStyles(styles)(observer(CreateQuickClip)));



// WEBPACK FOOTER //
// ./src/components/CreateQuickClip.js